export default "__VITE_ASSET__B3_x3EXR__"